module.exports = __webpack_public_path__ + "img/Managing_Director.17556b98.png";